var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper py-5",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('div',[_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_c('content-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }